
import drawPalette from "./drawPalette";

export default function (params) {

    const {
        canvas,
        palettes,
        height,
        paletteWidth,
        padding,
        vertical,
        // setIndexValue
    } = params;

    //  if (vertical){
    //      console.log("Drawing vertically!")
    //  }

    //  // check for null canvas
    //  if (!canvas){
    //      console.error("Can't draw to a null canvas, bucko!");
    //      return;
    //  }

    // set the height and width
    const width = ((padding + paletteWidth) * palettes.length) - padding;
    const scale = window.devicePixelRatio || 1;
    canvas.style.width = (vertical ? height : width) + "px";
    canvas.style.height = (vertical ? width : height) + "px";
    canvas.width = scale * (vertical ? height : width);
    canvas.height = scale * (vertical ? width : height);

    // get a context
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);
    ctx.imageSmoothingEnabled = false;
    const y = 0;
    const getX = i => i * (padding + paletteWidth);


    // draw palette
    palettes.forEach((p, i) => {

        drawPalette({
            ctx,
            x: getX(i),
            y,
            width: paletteWidth,
            height,
            swatches: p,
            vertical,
            proportional: params.proportional
        });

    })


}